<template>
  <el-row class="m-header m-header-topbar">
    <el-col :span="10">
      <LocateAddress />
    </el-col>
    <el-col :span="14">
      <TopNav />
    </el-col>
  </el-row>
</template>
<script>
import LocateAddress from "./LocateAddress.vue";
import TopNav from "./TopNav.vue";
export default {
  components: {
    LocateAddress,
    TopNav,
  },
};
</script>
<style lang="scss">
@import "@/assets/css/public/header/topbar.scss";
</style>
